/**
 * @fileoverview POST handler for the "/:app_group_id/generative_ai/campaign_qa/cancel" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdCampaignQaCancelCacheKeys } from "./constants";
import type {
  GenerativeAiAppGroupIdCampaignQaCancelResult,
  PostGenerativeAiAppGroupIdCampaignQaCancelProps,
} from "./types";

export const postGenerativeAiAppGroupIdCampaignQaCancel = reactQueryMutationAdapter(
  generativeAiAppGroupIdCampaignQaCancelCacheKeys,
  (
    props: PostGenerativeAiAppGroupIdCampaignQaCancelProps
  ): Promise<GenerativeAiAppGroupIdCampaignQaCancelResult> => {
    return fetch(
      `/${props.appGroupId}/generative_ai/campaign_qa/cancel`,
      "POST",
      { job_token: props.jobToken },
      undefined,
      {
        // Cancellation is best-effort: the run hook settles the UI locally, so
        // a failed cancel POST must not surface a blocking fetch-error modal.
        propagateFetchRequestError: false,
      }
    );
  }
);
